import { GrapheneRoot } from "@elsevier/graphene";
import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import queryClient from "./queryClient";
import routesConfig from "./routesConfig";
import "./styles/index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const router = createBrowserRouter(routesConfig);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <GrapheneRoot palette="graphene-1-light">
        <RouterProvider router={router} />
      </GrapheneRoot>
    </QueryClientProvider>
  </React.StrictMode>,
);
